import { Alert, Box, Text } from "@caspeco/casper-ui-library";
import { useExternalBookingSettings } from "api/api-hooks/use-external-booking-settings";
import { Trans } from "react-i18next";

const CancelNotPossibleAlert = () => {
    const { data: settings } = useExternalBookingSettings();

    if (!settings) {
        return null;
    }

    const name = settings.unitsMetaData.name;
    return (
        <Alert type="info">
            <Box>
                <Trans
                    i18nKey="notPossibleToCancelBooking"
                    values={{ name }}
                    components={{ bold: <Text as="span" fontWeight="bold" /> }}
                >
                    <Text as="span" fontWeight="bold" />
                </Trans>
            </Box>
        </Alert>
    );
};

export default CancelNotPossibleAlert;
